// The workflow type icons, drawn as the mockup draws them: one line glyph per type
const iconProps = {
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const
}

export const SequentialIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={className}>
    <circle cx="2.4" cy="8" r="1.5" />
    <path d="M4.6 8h3.6M6.7 6.3 8.4 8 6.7 9.7M9.6 8h4.4M12.3 6.3 14 8l-1.7 1.7" />
  </svg>
)

export const ParallelIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={className}>
    <path d="M2 4.5h11M2 8h11M2 11.5h11M10.8 2.7 13 4.5l-2.2 1.8M10.8 6.2 13 8l-2.2 1.8M10.8 9.7l2.2 1.8-2.2 1.8" />
  </svg>
)

export const LoopIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={className}>
    <path d="M13 8a5 5 0 1 1-1.6-3.7" />
    <path d="M11.8 1.9 11.6 4.6 8.9 4.4" />
  </svg>
)

export const GraphIcon = ({ className }: { className?: string }) => (
  <svg {...iconProps} className={className}>
    <path d="M1.8 8h4.4l6.3-4.2M6.2 8l6.3 4.2M10.3 2.6l2.4 1.1-1 2.4M10.3 13.4l2.4-1.1-1-2.4" />
  </svg>
)

// The glyph of each workflow type, shared by the table badge and the graph nodes
export const WORKFLOW_TYPE_ICONS = {
  sequential: SequentialIcon,
  parallel: ParallelIcon,
  loop: LoopIcon,
  graph: GraphIcon
} as const

// The workflow's own icon, the mockup's: three linked boxes, for any workflow
// The workflow's own icon, the mockup's: three linked boxes, for any workflow. A node draws it
// heavier than the drawer does.
export const WorkflowIcon = ({
  className,
  strokeWidth = 1.25
}: {
  className?: string
  strokeWidth?: number
}) => (
  <svg {...iconProps} strokeWidth={strokeWidth} className={className}>
    <rect x="5.75" y="1.5" width="4.5" height="4" rx="1" />
    <rect x="1.5" y="10.5" width="4.5" height="4" rx="1" />
    <rect x="10" y="10.5" width="4.5" height="4" rx="1" />
    <path d="M8 5.5V8M3.75 10.5V8h8.5v2.5" />
  </svg>
)
